((window, document) => {
  window.addEventListener('load', async () => {
    const el = document.querySelector('#store-locator');
    if (!el) {
      return;
    }

    import('./mapbox/index.js');
  });
})(window, document);
